import styled, { css } from 'styled-components';
import { ModalLayout, Text } from 'components';
import { lineHeight, theme, toRem } from 'design';
import { Subtitle } from 'modals/styles';

interface ILayoutProps {
  maxWidth?: number;
  center?: boolean;
}

export const Layout = styled(ModalLayout)<ILayoutProps>`
  width: 100%;
  max-width: ${toRem(600)};

  ${({ center }) =>
    center &&
    css`
      align-items: center;
    `}

  header {
    padding-bottom: ${toRem(theme.space.lg)};
  }
`;

export const StyledSubtitle = styled(Subtitle)`
  font-size: ${toRem(theme.font.size.md)};
  margin-top: ${toRem(theme.space.xs)};
  line-height: ${lineHeight(theme.font.size.md)};
`;

export const ResultsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: start;
  margin-bottom: ${toRem(theme.space.lg)};
`;

export const Wrapper = styled.div<ILayoutProps>`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: start;

  ${({ center }) =>
    center &&
    css`
      align-items: center;
    `}

  button {
    width: 100%;
  }
`;

export const ContentFooter = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: center;
  margin-top: ${toRem(theme.space.lg)};
`;

export const FooterAction = styled.div``;

export const SearchBar = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${toRem(theme.space.lg)};
`;

export const ActionText = styled(Text)`
  margin-right: ${toRem(theme.space.xs)};
  color: ${theme.color.primary[500]};

  &:hover {
    cursor: pointer;
    color: ${theme.color.primary[600]};
  }
`;

export const SplitScreen = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 100%;
  grid-gap: ${toRem(theme.space.lg)};

  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(theme.borderRadius.small)};
  margin-bottom: ${toRem(theme.space.lg)};
  background-color: ${theme.color.neutral[25]};

  @media (min-width: ${theme.breakpoint.small}px) {
    grid-template-columns: repeat(1, minmax(auto, 100%)) auto repeat(1, minmax(auto, 100%));
    align-items: center;
    grid-gap: ${toRem(theme.space.lg)};
  }
`;
